<div #fullscreen>
  <ngx-extended-pdf-viewer [base64Src]="base64Src$ | async"
                           [customToolbar]="customToolbar"
                           [filenameForDownload]="filenameForDownload"
                           [height]="height" [useBrowserLocale]="true">
  </ngx-extended-pdf-viewer>
</div>

<ng-template #customToolbar>

  <div id="toolbarViewer">
    <div id="toolbarViewerLeft">
      <pdf-toggle-sidebar></pdf-toggle-sidebar>
      <div class="toolbarButtonSpacer"></div>
      <pdf-find-button [showFindButton]="showFindButton" [textLayer]="textLayer"></pdf-find-button>
      <pdf-paging-area></pdf-paging-area>
    </div>
    <div id="toolbarViewerRight">
      <pdf-select-tool></pdf-select-tool>
      <pdf-hand-tool *ngIf="showHandToolButton"></pdf-hand-tool>
      <pdf-rotate-page></pdf-rotate-page>

      <button (click)="toggleFullScreen()" *ngIf="showOpenFullscreenBtn" class="toolbarButton new-tab hiddenMediumView"
              matTooltip="Open Fullscreen" type="button">
        <mat-icon>fullscreen</mat-icon>
      </button>

      <button (click)="toggleFullScreen()" *ngIf="!showOpenFullscreenBtn" class="toolbarButton new-tab hiddenMediumView"
              matTooltip="Close Fullscreen" type="button">
        <mat-icon>fullscreen_exit</mat-icon>
      </button>

      <pdf-print></pdf-print>
      <pdf-download *ngIf="showDownloadButton"></pdf-download>
      <div class="verticalToolbarSeparator hiddenSmallView"></div>
      <pdf-toggle-secondary-toolbar></pdf-toggle-secondary-toolbar>
    </div>
    <pdf-zoom-toolbar></pdf-zoom-toolbar>
  </div>
</ng-template>

